var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.2003,
    cy: 12.4577,
    r: 11.7003,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.52311 8.39087C7.09669 8.39087 6.68775 8.5429 6.38623 8.81353C6.08471 9.08415 5.91531 9.4512 5.91531 9.83392V15.0814C5.91531 15.4641 6.08471 15.8311 6.38623 16.1018C6.68775 16.3724 7.09669 16.5244 7.52311 16.5244H16.8776C17.304 16.5244 17.7129 16.3724 18.0144 16.1018C18.316 15.8311 18.4853 15.4641 18.4853 15.0814V9.83392C18.4853 9.4512 18.316 9.08415 18.0144 8.81353C17.7129 8.5429 17.304 8.39087 16.8776 8.39087H7.52311ZM9.52847 10.5612C9.43316 10.5054 9.3174 10.485 9.20566 10.5044C9.09392 10.5238 8.99495 10.5814 8.92967 10.665C8.86438 10.7487 8.8379 10.8519 8.85581 10.9528C8.87373 11.0536 8.93464 11.1443 9.02567 11.2056L11.9489 13.0422C12.0226 13.0885 12.1104 13.1133 12.2003 13.1133C12.2903 13.1133 12.378 13.0885 12.4517 13.0422L15.375 11.2056C15.4242 11.1768 15.4665 11.1393 15.4993 11.0955C15.5321 11.0517 15.5547 11.0025 15.5659 10.9507C15.577 10.8989 15.5765 10.8456 15.5642 10.794C15.552 10.7423 15.5283 10.6935 15.4945 10.6502C15.4608 10.607 15.4177 10.5703 15.3679 10.5423C15.3181 10.5144 15.2624 10.4957 15.2044 10.4874C15.1463 10.4791 15.087 10.4813 15.0299 10.494C14.9729 10.5067 14.9192 10.5295 14.8722 10.5612L12.2003 12.2399L9.52847 10.5612Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailicon);
export default __webpack_public_path__ + "static/media/mailicon.4f76b9a613bbd83f798751de834d7e99.svg";
export { ForwardRef as ReactComponent };